<template>
  <TheNuxtLink
    :to="linkTo(title) + (source ? `?s=${source}` : '')"
    class="block relative"
    :class="{ 'mb-12': !hideTitle }"
  >
    <TitleCover :title="title" res="512" />
    <p
      class="absolute left-0 mt-1 h-10 transition-opacity duration-300 delay-200 w-full line-clamp-2 text-sm"
      :class="{
        'opacity-0 pointer-events-none !delay-0': hideTitle,
      }"
    >
      {{ extractFromLocale(locale, title.attributes.title) }}
    </p>
  </TheNuxtLink>
</template>

<script setup lang="ts">
import type { TitleEntity } from "~/src/api";

defineProps<{
  title: TitleEntity;
  hideTitle?: boolean;
  // optional source appended to route for analytics (s=_)
  source?: string;
}>();

const locale = useNuxtApp().$i18n.global.locale;
</script>
